module.exports = __webpack_public_path__ + "static/media/search-icon-2.dd199233.svg";